import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { SimpleModal } from './SimpleModal';

export const TermsCheckbox = ({ checked, onChange, testId = 'terms-checkbox', error }) => (
  <div style={{ margin: '0.75rem 0' }}>
    <label style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem', fontSize: '0.88rem', color: '#4a5568', cursor: 'pointer' }}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={testId} style={{ marginTop: 3, width: 16, height: 16, accentColor: '#14b8a6' }} />
      <span>Li e aceito os <a href="/termos-de-uso" target="_blank" rel="noopener noreferrer" data-testid={`${testId}-link`} style={{ color: '#0d9488', fontWeight: 600, textDecoration: 'underline' }}>Termos de uso</a></span>
    </label>
    {error && <p data-testid={`${testId}-error`} style={{ color: '#c53030', fontSize: '0.8rem', marginTop: 4 }}>{error}</p>}
  </div>
);

export const TermsAcceptModal = ({ onAccept, onCancel }) => {
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const accept = async () => {
    if (!checked) return setError('Marque a caixa para continuar');
    setBusy(true);
    try {
      await onAccept();
    } catch {
      setError('Não foi possível registrar o aceite. Tente novamente.');
      setBusy(false);
    }
  };
  return (
    <SimpleModal title="Termos de uso da Livrum" onClose={onCancel} testId="terms-accept-modal">
      <p style={{ color: '#4a5568', fontSize: '0.9rem', lineHeight: 1.6 }}>
        Atualizamos nossos Termos de uso. Para continuar usando a plataforma, leia e aceite os termos.
      </p>
      <TermsCheckbox checked={checked} onChange={(v) => { setChecked(v); setError(''); }} testId="terms-accept-checkbox" error={error} />
      <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
        <Button type="button" variant="outline" onClick={onCancel} style={{ flex: 1 }} data-testid="terms-accept-cancel-btn">Sair</Button>
        <Button type="button" onClick={accept} disabled={busy} style={{ flex: 1, background: '#0d9488', color: 'white' }} data-testid="terms-accept-continue-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Aceitar e continuar'}
        </Button>
      </div>
    </SimpleModal>
  );
};
